import { css } from '@emotion/react';
import { layout, breakpoint } from '~/theme';

export const setMediumSpacing = (property) => css`
    ${property}: ${layout.sectionPaddingMediumMobile};

    @media (min-width: ${breakpoint.tablet}) {
        ${property}: ${layout.sectionPaddingMediumTablet};
    }

    @media (min-width: ${breakpoint.desktop}) {
        ${property}: ${layout.sectionPaddingMedium};
    }
`;

export const setSectionSpacing = (property) => css`
    ${property}: ${layout.sectionPaddingMobile};

    @media (min-width: ${breakpoint.tablet}) {
        ${property}: ${layout.sectionPaddingTablet};
    }

    @media (min-width: ${breakpoint.desktop}) {
        ${property}: ${layout.sectionPadding};
    }
`;

export const setSmallSpacing = (property) => css`
    ${property}: ${layout.sectionPaddingSmallMobile};

    @media (min-width: ${breakpoint.tablet}) {
        ${property}: ${layout.sectionPaddingSmallTablet};
    }

    @media (min-width: ${breakpoint.desktop}) {
        ${property}: ${layout.sectionPaddingSmall};
    }
`;

export const sectionSpacing = (property) => css`
    ${setSectionSpacing(property)};
`;

export const mediumSpacing = (property) => css`
    ${setMediumSpacing(property)};
`;

export const smallSpacing = (property) => css`
    ${setSmallSpacing(property)};
`;

export const getSectionSpacing = (size, property) => {
    let spacing = sectionSpacing(property); // Default spacing.

    switch (size) {
        case 'medium':
            spacing = mediumSpacing(property);
            break;
        case 'small':
            spacing = smallSpacing(property);
            break;
        case 'none':
            spacing = css``;
            break;
        default:
            spacing = sectionSpacing(property);
    }

    return spacing;
};
